// Comptes GoTrue EXISTANTS (§10) — aucun compte à recréer, aucun rôle interne
// à FlashCP : tout utilisateur connecté peut tout faire sur une run.
// L'administration des comptes reste dans SotCP V3.

import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import type { Session, User } from '@supabase/supabase-js'
import { supabase } from './supabase'

interface Auth {
  session: Session | null
  user: User | null
  nom: string
  pret: boolean
  connexion: (email: string, motDePasse: string) => Promise<void>
  deconnexion: () => Promise<void>
}

const Ctx = createContext<Auth | null>(null)

/** Même règle d'affichage que fc_acteur_nom() côté SQL — les deux doivent coïncider. */
export function nomAffiche(user: User | null): string {
  const m = (user?.app_metadata ?? {}) as Record<string, unknown>
  const prenom = typeof m.first_name === 'string' ? m.first_name : ''
  const nom    = typeof m.last_name === 'string' ? m.last_name : ''
  const complet = `${prenom} ${nom}`.trim()
  return complet || user?.email || 'inconnu'
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null)
  const [pret, setPret] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session)
      setPret(true)
    })
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s))
    return () => sub.subscription.unsubscribe()
  }, [])

  const valeur: Auth = {
    session,
    user: session?.user ?? null,
    nom: nomAffiche(session?.user ?? null),
    pret,
    connexion: async (email, motDePasse) => {
      const { error } = await supabase.auth.signInWithPassword({ email, password: motDePasse })
      if (error) throw error
    },
    deconnexion: async () => { await supabase.auth.signOut() },
  }

  return <Ctx.Provider value={valeur}>{children}</Ctx.Provider>
}

export function useAuth(): Auth {
  const c = useContext(Ctx)
  if (!c) throw new Error('useAuth hors AuthProvider')
  return c
}
